const ITEMS = [
  "CUSTOM BOX MAKERS — KAMPALA",
  "GIFT ◆ PIZZA ◆ CAKE ◆ BURGER",
  "CHALK ◆ JUICE ◆ ROUND TAKEAWAY",
  "PAPER BAGS ◆ SOS & ROPE-HANDLE",
  "PACKAGING & CORRUGATED",
  "BULK WHOLESALE & RETAIL",
  "SUSTAINABLE KRAFT",
  "QUICK QUOTE FULFILLMENT",
];

export default function Marquee() {
  const row = (hidden) => (
    <div aria-hidden={hidden} className="flex items-center shrink-0">
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-display font-medium tracking-wide text-lg sm:text-2xl text-kraft/80 px-8 whitespace-nowrap">
            {t}
          </span>
          <span className="text-mint text-xl">✦</span>
        </span>
      ))}
    </div>
  );

  return (
    <div className="relative border-y border-mint/15 bg-moss/30 py-5 overflow-hidden" data-testid="marquee-band">
      <div className="marquee-track">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
